<div class="content-wrapper">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">

        <div class="card-body">
          <h4 class="card-title">Contractors</h4>
       

          <div class="card">

            <p>Count: {{size}}</p>
            <p-table #dt2 [value]="Vendors" dataKey="id" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10,25,50]" [loading]="loading" [paginator]="true"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [(contextMenuSelection)]="UpdateVendor" [contextMenu]=""
              [globalFilterFields]="['name','email','contactPerson','contactPersonEmail']">
              <ng-template pTemplate="caption">

                <div class="form-group">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="search" aria-label="Recipient's username"
                      (input)="dt2.filterGlobal($event.target.value, 'contains')">
                    <div class="input-group-append">
                      <button class="btn btn-sm btn-primary" type="button">Search</button>
                    </div>
                  </div>
                </div>
                <div class="input-group-append">
                  <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                </div>

           
              </ng-template>

              <ng-template pTemplate="header">

                <tr>
            
                  <th>Name</th>
                  <th>Email</th>
                  <th>Contact</th>
                  <th>Contractor Type</th>
                  <th>
                    Action
                  </th>

                </tr>

                <tr>
                  <th></th>

                  <th></th>

                  <th></th>

                  <th></th>

                  <th></th>

              
                 

                </tr>

              </ng-template>

              <ng-template pTemplate="body" let-data>
                <tr (contextmenu)="contextMenu($event, menu, data)"   >

                 
                  <td>
                    {{data.name}}
                  </td>

                  <td>
                    {{data.email}}
                  </td>

                  <td>
                     {{data.contactPerson}}
                  </td>

                  <td>
                    {{data.contractorType}}
                  </td>

               

                  <td>
                      <button pButton pRipple icon="pi pi-check" class="p-button-rounded p-button-warning" (click)="viewVendor(data)"></button>
                      <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" (click)="editVendor(data)"></button>
                </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="5">No Contractor found.</td>
                </tr>
              </ng-template>

            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item  >View</li>
    


  </ul>
</nz-dropdown-menu>


<p-dialog [(visible)]="editDialog" [style]="{width: '450px'}" header="Vendor Details" [modal]="true" styleClass="p-fluid">
  <ng-template pTemplate="content">
      
      <div class="form-group">
          <label for="name">Name</label>
          <input type="text"  id="name" [(ngModel)]="UpdateVendor.name" required autofocus  class="form-control" />
          <small class="p-error" *ngIf="submitted && !UpdateVendor.name">Name is required.</small>
      </div>

 



      <div class="form-group">
        <label for="name">Email</label>
        <input type="text" pInputText id="email" [(ngModel)]="UpdateVendor.email" required autofocus  class="form-control"/>
        <small class="p-error" *ngIf="submitted && !UpdateVendor.email">Email is required.</small>
    </div>
    <div class="form-group">
      <label for="name">Phone</label>
      <input type="text" pInputText id="phone" [(ngModel)]="UpdateVendor.phone" required autofocus  class="form-control"/>
      <small class="p-error" *ngIf="submitted && !UpdateVendor.phone">Phone is required.</small>
  </div>


      <div class="form-group">
          <label for="address">Address</label>
          <textarea id="address" pInputTextarea [(ngModel)]="UpdateVendor.address" required rows="3" cols="20"  class="form-control"></textarea>
      </div>
      <div class="form-group">
        <label for="description">Description</label>
        <textarea id="description" pInputTextarea [(ngModel)]="UpdateVendor.description" required rows="3" cols="20"  class="form-control"></textarea>
    </div>


      <div class="field">
        <label for="name">Contact Person</label>
        <input type="text" pInputText id="contactPerson" [(ngModel)]="UpdateVendor.contactPerson" required autofocus  class="form-control"/>
        <small class="p-error" *ngIf="submitted && !UpdateVendor.contactPerson">Contact Person is required.</small>
    </div>
    <div class="form-group">
      <label for="name">Contact Person Email</label>
      <input type="text"  class="form-control" pInputText id="contactPersonEmail" [(ngModel)]="UpdateVendor.contactPersonEmail" required autofocus />
      <small class="p-error" *ngIf="submitted && !UpdateVendor.contactPersonEmail">Contact Person  Emailis required.</small>
  </div>



      <div class="field">
          <label for="contractorType">Category </label>
          <p-dropdown [(ngModel)]="UpdateVendor.contractorType" inputId="contractorType" [options]="statuses" placeholder="Select">
              <ng-template let-option pTemplate="item">
                  <span [class]="'UpdateVendor-badge status-' + option.value">{{option.label}}</span>
              </ng-template>
          </p-dropdown>
      </div>

  

    
  </ng-template>

  <ng-template pTemplate="footer">
      <button pButton pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
      <button pButton pRipple label="Save" icon="pi pi-check" class="p-button-text" (click)="saveEdit()" *ngIf="isEditing"></button>
  </ng-template>
</p-dialog>